import { render, staticRenderFns } from "./OrdersFBAEdit.vue?vue&type=template&id=2b3e19b6&scoped=true"
import script from "./OrdersFBAEdit.vue?vue&type=script&lang=js"
export * from "./OrdersFBAEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e19b6",
  null
  
)

export default component.exports